import {createAppKit} from '@reown/appkit/react'
import {EthersAdapter} from '@reown/appkit-adapter-ethers'
import {mainnet, bsc} from '@reown/appkit/networks'

const projectId = '0ca77410fed3c7f4d6800fc0718b89e2'

export const networks = [mainnet, bsc]

const metadata = {
    name: 'Coldware',
    description: 'Coldware Network️ Layer-1® Blockchain Solution',
    url: process.env.REACT_APP_URL, // origin must match your domain & subdomain
    icons: ['https://avatars.mywebsite.com/']
}

createAppKit({
    adapters: [new EthersAdapter()],
    networks,
    metadata,
    projectId,
    themeMode: 'light',
    enableWalletConnect: true,
    features: {
        connectMethodsOrder: ['wallet'],
        analytics: true, // Optional - defaults to your Cloud configuration,
        swaps: false,
        send: false,
        onramp: true
    }
})



export default function WalletConnector() {
    return (
        <div>
            <appkit-button/>
        </div>
    )
}